import React, {cloneElement} from 'react';
import {entities} from '../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../util/utils';
import Utility from '../../../../../../../util/utilityfunctions';
import ViewControls from './entities/Control/ViewControls';
import ViewItControlsList from './entities/ItControl/ViewItControlsList';

export const EntityComponentConfig = {
	[entities.ItRisk]: {
		render: (props, ref, children) => {
			/*ToDo: */
		}
	},
	[entities.ItSoApplication]: {
		render: (props, ref, children) => {
			/*ToDo: */
		}
	},
	[entities.ItControl]: {
		render: (props, ref, children) => cloneElement(<ViewItControlsList ref={ref} />, props, children)
	},
	[entities.SCOT]: {
		render: (props, ref, children) => {
			/*ToDo: */
		}
	},
	[entities.Control]: {
		render: (props, ref, children) => cloneElement(<ViewControls ref={ref} />, props, children)
	},
	default: null
};

const common = {
	confirmBtnTitle: labels.saveLabel,
	closeBtnTitle: labels.closeLabel,
	cancelBtnTitle: labels.closeLabel,
	hideConfirmButton: true,
	showButtons: true,
	modalSize: 'medium',
	createNewBtnTitle: labels.saveAndCreateNewButtonTitle,
	showCreateNew: false
};

export const EntityConfiguration = {
	[entities.ItRisk]: () => {
		return {
			...common
		};
	},
	[entities.ItSoApplication]: () => {
		return {
			...common
		};
	},
	[entities.ItControl]: (props) => {
		return {
			...common,
			// To be reused for show unrelated ITSPs
			modalTitle: props.modalTitle,
			modalDescription: props.modalDescription,
			onModalHide: props.onModalHide
		};
	},
	[entities.SCOT]: () => {
		return {
			...common
		};
	},
	[entities.Control]: (props) => {
		return {
			...common,
			modalTitle: labels.viewControl,
			modalDescription: Utility.getViewModalDescription(props.scotName, 'entityNameBold')
		};
	},
	default: () => {
		return {
			...common
		};
	}
};

export const getEntityBodyComponent = (entityId) => {
	if (entityId && EntityComponentConfig.hasOwnProperty(entityId)) {
		return EntityComponentConfig[entityId];
	}
	return EntityComponentConfig.default;
};

export const getEntityModalConfiguration = (entityId) => {
	if (entityId && EntityConfiguration.hasOwnProperty(entityId)) {
		return EntityConfiguration[entityId];
	}
	return EntityConfiguration.default;
};
